import React from "react";
import "./App.css";
import NavBarLayout from "./NavbarLayout";
import { useNavigate } from "react-router-dom";
import { IoSearch } from "react-icons/io5";
import { iconColor } from "./colors";
import { IoChatbox } from "react-icons/io5";
import {
  fakeSearchEngine,
  getIndexFromUsername,
  getRandomLocalUser,
  getRandomNumber,
  getRandomUsernames,
} from "./Data";
import Generic from "./icons/Purple Profile.png";

function FriendEntry(props) {
  const navigate = useNavigate();
  const { username, pfp } = props;

  return (
    <div
      onClick={() => navigate(`/friend?user=${getIndexFromUsername(username)}`)}
      className="FriendEntry-container"
    >
      <img className="FriendsCard-pfp" src={pfp} alt=""></img>
      <div className="FriendEntry-username">{username}</div>
      {props.rightIcon && <IoChatbox size="2rem" color={iconColor} />}
    </div>
  );
}

function FriendsSearch() {
  const [activeTab, setActivetab] = React.useState(0);
  const [isSearching, setIsSearching] = React.useState(false);
  const [value, setValue] = React.useState("");
  const inputRef = React.useRef();
  const navigate = useNavigate();

  let dataKey = "friendsSearch";
  let numFriends, friends;
  if (activeTab === 1) {
    dataKey += "pending";
    numFriends = getRandomNumber(dataKey, 2, 4);
    friends = getRandomUsernames(dataKey, numFriends).map((username) => ({
      username,
      pfp: Generic,
    }));
  } else if (isSearching || value.length !== 0) {
    if (value.length === 0) {
      dataKey += "recent";
      numFriends = getRandomNumber(dataKey, 3, 6);
      friends = getRandomLocalUser(dataKey, numFriends);
    } else {
      dataKey += "searching";
      friends = fakeSearchEngine(value);
    }
  } else {
    numFriends = getRandomNumber(dataKey, 3, 6);
    friends = getRandomLocalUser(dataKey, numFriends);
  }

  return (
    <NavBarLayout
      title="Friends"
      onBackButtonClicked={() => navigate("/friendsfeed")}
      active={2}
    >
      <div className="FriendsFeed-container">
        <div className="FriendsSearch-upper">
          <div style={{ padding: "1rem 2rem" }}>
            <div
              onClick={() => inputRef.current.focus()}
              className="FriendsSearch-searchContainer"
            >
              <IoSearch
                style={{ margin: "0 1rem" }}
                size="2.5rem"
                color={iconColor}
              />
              <input
                ref={inputRef}
                value={value}
                onChange={(event) => setValue(event.target.value)}
                onBlur={() => setIsSearching(false)}
                onFocus={() => setIsSearching(true)}
                placeholder="Search For Friends"
                className="FriendsSearch-search"
                type="text"
              ></input>
            </div>
          </div>
          <div
            className="FriendsFeed-upperBar"
            style={isSearching ? { justifyContent: "flex-start" } : {}}
          >
            {isSearching || value.length !== 0 ? (
              value.length === 0 ? (
                <div className="FriendsFeed-tab">Recently Viewed</div>
              ) : null
            ) : (
              <>
                <div
                  onClick={() => setActivetab(0)}
                  className={`FriendsFeed-tab ${
                    activeTab === 0 ? "FriendsFeed-tabActive" : ""
                  }`}
                >
                  Friends
                </div>
                <div
                  onClick={() => setActivetab(1)}
                  className={`FriendsFeed-tab ${
                    activeTab === 1 ? "FriendsFeed-tabActive" : ""
                  }`}
                >
                  Pending
                </div>
              </>
            )}
          </div>
        </div>
        <div className="FriendsFeed-mainScrollContainer">
          <div className="FriendsFeed-mainScroll">
            {friends.map((friend) => {
              return (
                <FriendEntry
                  rightIcon={
                    activeTab === 0 && !isSearching && value.length === 0
                  }
                  {...friend}
                />
              );
            })}
          </div>
        </div>
      </div>
    </NavBarLayout>
  );
}

export default FriendsSearch;
